/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CampaignState, CAMPAIGN_STATE_CLASSES } from 'cio/models/campaign';

// This component is used both for the power select dropdown list, as well as
// selected item component, which currently pass in differently named params
interface CampaignsFilterGroupStateDropdownItemArgs {
  item?: { label: string; value: CampaignState };
  option?: { label: string; value: CampaignState };
}

export default class CampaignsFilterGroupStateDropdownItem extends Component<CampaignsFilterGroupStateDropdownItemArgs> {
  get item() {
    if (this.args.item != null) {
      return this.args.item;
    }

    if (this.args.option != null) {
      return this.args.option;
    }

    return null;
  }
  get labelClass() {
    if (this.item == null) {
      return null;
    }

    return CAMPAIGN_STATE_CLASSES[this.item.value];
  }
}
